import { observable, action } from 'mobx';
import { setter } from 'mobx-decorators';
import agent from '../services/web/agent';
import CommonValidator from '../services/validations/commonValidators';
import AuthStore from './authStore';
import ConfigurationsStore from './configurationsStore';
    
class AdminConfigurationStore {
    @observable updateInProgress = false;
    @setter @observable twoFAEnforced;
    @observable displayForgotPasswordLink = true;
    @observable recoveryCodeCount = 0;
    @observable recoveryCodeCountValidationMessage = '';
    @observable twoFactorSettingFormErrors = [];
    @observable isRecoveryCodeCountValid = false;
    @setter @observable userInactivity = 0;

    @action toggleMandateTwoFA() {
        this.twoFAEnforced = !this.twoFAEnforced;
    }

    setRecoveryCodeCount(val) {
        this.recoveryCodeCount = val;
    }

    validateRecoveryCodeCount() {
       const validation = CommonValidator.validateRecoveryCodeCount(this.recoveryCodeCount);
        this.recoveryCodeCountValidationMessage = validation.errors.first('field');
        this.twoFactorSettingFormErrors.push(validation.errorCount);
        this.isRecoveryCodeCountValid = validation.errorCount == 0 ? true : false;
    }

    @action getTwoFactorSettings() {
        return agent.TenantConfiguration.getTwoFactorAuthSettings()
            .then(action((data) => {
                this.twoFAEnforced = data.twoFAEnforced;
                this.recoveryCodeCount = data.recoveryCodeCount;
            }));
    }

    @action setTwoFactorSettings() {
        return agent.TenantConfiguration.setTwoFactorAuthSettings(this.twoFAEnforced, this.recoveryCodeCount)
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }));
    }

    @action validateTwoFactorSettingForm() {
        this.twoFactorSettingFormErrors = [];
        this.validateRecoveryCodeCount();
        if (this.twoFactorSettingFormErrors.filter((valid) => valid > 0).length > 0) {
            return false;
        }
        return true;
    }

    @action getForgotPasswordSetting() {
        if (ConfigurationsStore.isMultitenancyMode)
            return agent.TenantConfiguration.getForgotPasswordSettingsForTenant(AuthStore.values.tenant)
                .then(action((data) => {
                    this.displayForgotPasswordLink = data;
                }));
        else
            return agent.TenantConfiguration.getForgotPasswordSettings()
                .then(action((data) => {
                    this.displayForgotPasswordLink = data;
                }));
    }

    @action getUserInactivitySetting() {
      return agent.TenantConfiguration.getUserInactivity()
                .then(action((data) => {
                    this.userInactivity = data;
                }));
    }

    @action setUserInactivitySetting() {
      console.log(this.userInactivity);
      this.updateInProgress = true;
      return agent.TenantConfiguration.setUserInactivity(this.userInactivity).then(() => {
          this.updateInProgress = false;
      });
    }
}

export default new AdminConfigurationStore();



// WEBPACK FOOTER //
// ./src/stores/adminConfigurationStore.js